import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const WAPP_NUMBER = "22890119255";
const SALES_EMAIL = "contact@mameche.tg";
const PHONE = "+228 90 11 92 55";
const ADDRESS = "Lomé, Togo";
const MAP_URL = "https://maps.google.com/?q=Lomé,Togo";

const wapp = (txt) => `https://wa.me/${WAPP_NUMBER}?text=${encodeURIComponent(txt)}`;
const mailto = (subject, body) =>
  `mailto:${SALES_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export default function Footer() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 320);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const year = new Date().getFullYear();

  return (
    <footer className="mt-5 border-top bg-light">
      {/* Bandeau CTA compact */}
      <div className="border-bottom" style={{ background: "linear-gradient(135deg,#E8F5E9,#C8E6C9)" }}>
        <div className="container py-3 d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
          <strong className="text-dark">Un besoin ? Nous répondons sous 24–48h.</strong>
          <div className="d-flex gap-2 flex-wrap">
            <a
              className="btn btn-success btn-sm"
              href={wapp("Bonjour 👋, je souhaite un devis pour des équipements.")}
              target="_blank"
              rel="noreferrer"
            >
              Devis rapide →
            </a>
            <Link to="/contact" className="btn btn-outline-dark btn-sm">Formulaire</Link>
            <a className="btn btn-outline-secondary btn-sm" href={mailto("Question rapide", "Bonjour,\n\n")} >
              Email
            </a>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-12 col-md-4">
            <h5 className="fw-bold mb-2">MAMECHE</h5>
            <p className="small text-muted mb-2">
              Matériels médico-chirurgicaux, consommables, réactifs de laboratoire & solutions industrielles.
            </p>
            <div className="small">
              <div className="mb-1">📍 <a href={MAP_URL} className="text-reset footer-link" target="_blank" rel="noreferrer">{ADDRESS}</a></div>
              <div className="mb-1">📞 <a href={`tel:${PHONE.replace(/\s/g,"")}`} className="text-reset footer-link">{PHONE}</a></div>
              <div className="mb-1">✉️ <a href={`mailto:${SALES_EMAIL}`} className="text-reset footer-link">{SALES_EMAIL}</a></div>
              <div>💬 <a href={wapp("Bonjour, j’aimerais échanger avec un conseiller.")} className="text-reset footer-link" target="_blank" rel="noreferrer">WhatsApp</a></div>
            </div>
          </div>

          <div className="col-6 col-md-2">
            <h6 className="fw-bold">Liens</h6>
            <ul className="list-unstyled small">
              <li><Link to="/" className="text-reset footer-link">Accueil</Link></li>
              <li><Link to="/about" className="text-reset footer-link">À propos</Link></li>
              <li><Link to="/contact" className="text-reset footer-link">Contact</Link></li>
              <li><Link to="/about" className="text-reset footer-link">Politique qualité</Link></li>
            </ul>
          </div>

          <div className="col-6 col-md-3">
            <h6 className="fw-bold">Catalogues</h6>
            <ul className="list-unstyled small">
              <li><Link to="/medical/products" className="text-reset footer-link">Produits Médicaux</Link></li>
              <li><Link to="/industrial/products" className="text-reset footer-link">Produits Industriels</Link></li>
              <li><Link to="/#featured" className="text-reset footer-link">Produits phares</Link></li>
              <li><Link to="/about" className="text-reset footer-link">Nos réalisations</Link></li>
            </ul>
          </div>

          <div className="col-12 col-md-3">
            <h6 className="fw-bold">Rester informé</h6>
            <p className="small text-muted">Recevez nos arrivages & promos (occasionnellement).</p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const email = e.currentTarget.email.value.trim();
                if (!email) return;
                window.location.href = mailto("Inscription newsletter", `Bonjour,\n\nMerci d’inscrire ${email} à votre newsletter.\n`);
              }}
              className="d-flex gap-2"
            >
              <input name="email" type="email" required className="form-control form-control-sm" placeholder="Votre email" />
              <button type="submit" className="btn btn-success btn-sm">OK</button>
            </form>
          </div>
        </div>
      </div>

      {/* Bas de page */}
      <div className="border-top">
        <div className="container py-3 d-flex flex-column flex-md-row justify-content-between align-items-center small text-muted">
          <div>© {year} MAMECHE — Tous droits réservés</div>
          <div className="d-flex gap-3">
            <Link to="/about" className="text-reset footer-link">Mentions</Link>
            <Link to="/about" className="text-reset footer-link">Politique qualité</Link>
            <Link to="/contact" className="text-reset footer-link">Support</Link>
          </div>
        </div>
      </div>

      {/* Back to top */}
      {showTop && (
        <button
          type="button"
          aria-label="Revenir en haut"
          className="btn btn-success shadow back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          ↑
        </button>
      )}
    </footer>
  );
}
